export default __webpack_public_path__ + "static/media/Maithili_book1_m.2b53afb8.wav";